<template>
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        width="auto"
    >
      <v-card>
        <v-toolbar color="primary" :title="$t('target.removeTarget')">
        </v-toolbar>
        <v-card-text>
          {{ $t("target.removeQuestion", { name: name }) }}
        </v-card-text>
        <v-card-actions>
          <v-btn variant="tonal" color="primary" prepend-icon="mdi-trash-can" @click="deleteTarget">{{ $t("target.delete") }}</v-btn>
          <v-btn variant="tonal" color="primary" prepend-icon="mdi-close-circle" @click="dialog = false">{{ $t("target.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {defineComponent} from "vue";
import {useTargetStore} from "@/stores/targetStore";
import { useShelterStore } from "@/stores/shelterStore";
export default defineComponent({
  data() {
    return {
      dialog: false,
      id: null,
      name: null
    }
  },
  methods: {
    showDialog(id, name) {
      this.$data.id = id
      this.$data.name = name
      this.$data.dialog = true
    },
    async deleteTarget() {
      if (this.$data.id) {
        await useTargetStore().deleteTarget(this.$data.id)
        await useShelterStore().getUserShelters()
      }
      this.$data.dialog = false
    }
  }
})
</script>
